import { FsEvent, Schema } from '@fullstory/fs-script-api';
import { EventFilter } from '@fullstory/proto/fs/api/segment';

export const addTimestamp = (record: Record<any, any>): Record<any, any> => ({
  ...record,
  timestamp_str: new Date().toISOString(),
});

export function createEventTracker<T extends Record<any, any>>(event: string) {
  return (properties: T) => {
    FsEvent.recordCustomEvent(event, addTimestamp(properties));
  };
}

export function createV2EventTracker<T extends Record<any, any>>(event: string, schema?: Schema) {
  return (properties: T) => {
    if (FsEvent.canRecordCustomEvent()) {
      FsEvent.recordCustomEventV2(event, addTimestamp(properties), schema);
    }
  };
}

export function eventFilterToString(filter?: EventFilter | null): string | null {
  if (filter == null) return null;
  const oneof = EventFilter.filter_oneof(filter);
  if (!oneof) return null;
  return EventFilter.filter[oneof.opt] ?? null;
}
